import { FC } from 'react'
import { ProfileComponent } from './ProfileComponent'
import { useParams } from 'react-router-dom'


export const RegisterPage: FC = () => {
    const { id } = useParams()
    return (
        <>
            <ProfileComponent mode='register' userProfileId={id ?? ''}  returnUrl={'/auth/login'} />
        </>
    )
}

